import { Button, Select, Space } from "antd";
import { findProgrammeStudent } from "api/services/studentReservation/studentReservation.services";
import Breadcrumbs from "components/breadcrumbs";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

//!COMPONENTS

//!IMAGES
import CalendarPicture from "../../../assets/images/app/calendar_icon.svg";

//!STYLES
import AppResult from "components/appResults";
import SessionsCalendarGridView from "components/classroomComponents/SessionsCalendarGridView/SessionsCalendarGridView";
import { CourseViewType } from "components/classroomComponents/types";
import Container from "components/container";
import { setOpenCoursesHistory } from "store/app/appSlice";
import { useGetOrganismRoomsQuery } from "store/services/teacher/classes.services";
import DrawerHistoriqueOrganism from "../classDetails/components/drawerHistoriqueOrganism";
import s from "./assets/calendar.module.css";
import CalendarOfReservationOrganism from "./components/calendarReservations";

const { Option } = Select;

const OrganismCalendar = () => {
  //!HOOK
  const { user } = useSelector((state) => state.auth);
  const { openCoursesHistory } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const { data: rooms, isLoading, isError, refetch } = useGetOrganismRoomsQuery(user?._id);

  //!STATE
  const [data, setData] = useState<any>();
  const [filter, setFilter] = useState<string[]>([]);
  const [visible, setVisible] = useState(false);
  const [openDrawerHistorique, setOpenDrawerHistorique] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedAd, setSelectedAd] = useState<any | null>(null);

  const [courseView, setCourseView] = useState<CourseViewType>('list');
  const [calendarData, setCalendarData] = useState<any>();
  const [filteredData, setFilteredData] = useState<any[]>([]);

  //!FUNCTION
  const showDrawer = () => setVisible(true);
  const onClose = () => setVisible(false);

  const getReservation = useCallback(async () => {
    setLoading(true);
    try {
      const response = await findProgrammeStudent(user?._id);
      if (response) {
        setData(response?.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  useEffect(() => {
    if (calendarData) {
      setFilteredData(calendarData);
    }
  }, [calendarData]);

  /* const handleFiltering = (value: string) => {
    setFilter(value);

    if (!value) {
      setFilteredData(calendarData);
      return;
    }

    let filtered = calendarData;

    if (value === 'all') {
      setFilteredData(calendarData);
    }
    else {
      filtered = calendarData.filter(
        (session: any) =>
          session.classeId &&
          session.classeId === value
      );

      setFilteredData(filtered);
    }
  }; */

  const handleFiltering = (value: string[]) => {
    // If user just selected "all", clear the rest
    if (value.includes('all') && !filter.includes('all')) {
      setFilter(['all']);
      setFilteredData(calendarData);
      return;
    }

    // If user selects a class while "all" was selected, remove "all"
    const cleaned = value.filter((v) => v !== 'all');

    if (cleaned.length === 0) {
      setFilter([]);
      setFilteredData(calendarData);
      return;
    }

    setFilter(cleaned);
    setFilteredData(
      calendarData.filter(
        (session: any) => session.classeId && cleaned.includes(session.classeId)
      )
    );
  };

  useEffect(() => {
    getReservation();
  }, []);

  useEffect(() => {
    if (openCoursesHistory) {
      setOpenDrawerHistorique(true);
      setTimeout(() => {
        dispatch(setOpenCoursesHistory(false));
      }, 2000);
    }
  }, [openCoursesHistory]);

  const THREE_DAYS_IN_MS = 3 * 24 * 60 * 60 * 1000;
  const NOW_IN_MS = new Date().getTime();

  const dateTimeAfterDays = NOW_IN_MS + THREE_DAYS_IN_MS;

  return (
    <React.Fragment>
      {isMobile && user?.accountManaged !== "" && <div style={{ height: "0px", width: "100%" }}></div>}
      {!isMobile && <Breadcrumbs isCalendar />}
      <div style={{ marginTop: "1em", marginBottom: "120px" }}>
        <Container>
          {isMobile ? <div className={s.headerBox}>
            <div className={s.headerBoxTitleFull}>
              <div className={s.titleBox}>
                <div className={s.titlePictureBox}>
                  <img src={CalendarPicture} height={isMobile ? 20 : 35}></img>
                </div>
                Planning des cours
              </div>

              <div className={s.buttonBox}>
                <Button className={s.newButton} onClick={() => setOpenDrawerHistorique(true)}>
                  Mon historique
                </Button>
              </div>
            </div>

            <div className={s.headerBoxTitle} style={{ marginTop: "15px" }}>
              <Space style={{ marginLeft: "10px" }}>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              <Select
                mode="multiple"
                value={filter}
                onChange={(value) => handleFiltering(value)}
                className="select-filter"
                placeholder={<span style={{ fontSize: "12px" }}>Filtrer</span>}
                menuItemSelectedIcon={null}
              >
                {rooms?.data?.map((room: any, index: number) => (
                  <Option key={index} value={room?._id}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input
                        type="checkbox"
                        readOnly
                        checked={filter.includes(room?._id)}
                        style={{ accentColor: '#5a9e9c', width: '14px', height: '14px' }}
                      />
                      <span>{room?.title}</span>
                    </div>
                  </Option>
                ))}
                <Option value="all">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="checkbox"
                      readOnly
                      checked={filter.includes('all')}
                      style={{ accentColor: '#5a9e9c', width: '14px', height: '14px' }}
                    />
                    <span>Toutes les réservations</span>
                  </div>
                </Option>
              </Select>
            </div>
          </div> : <div className={s.headerBox}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px" }}>
              <div className={s.titleBox}>
                <div className={s.titlePictureBox}>
                  <img src={CalendarPicture} height={isMobile ? 20 : 35}></img>
                </div>
                Planning des cours
              </div>

              <Space style={{ marginLeft: "10px" }}>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              <Select
                mode="multiple"
                value={filter}
                onChange={(value) => handleFiltering(value)}
                className="select-filter"
                placeholder={<span style={{ fontSize: "12px" }}>Filtrer</span>}
                menuItemSelectedIcon={null}
              >
                {rooms?.data?.map((room: any, index: number) => (
                  <Option key={index} value={room?._id}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input
                        type="checkbox"
                        readOnly
                        checked={filter.includes(room?._id)}
                        style={{ accentColor: '#5a9e9c', width: '14px', height: '14px' }}
                      />
                      <span>{room?.title}</span>
                    </div>
                  </Option>
                ))}
                <Option value="all">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="checkbox"
                      readOnly
                      checked={filter.includes('all')}
                      style={{ accentColor: '#5a9e9c', width: '14px', height: '14px' }}
                    />
                    <span>Toutes les réservations</span>
                  </div>
                </Option>
              </Select>
            </div>

            <div className={s.buttonBox}>
              <Button className={s.newButton} onClick={() => setOpenDrawerHistorique(true)}>
                Mon historique
              </Button>
            </div>
          </div>}

          {courseView === 'list' ? <div className={s.calendrier}>
            <div className={s.calendar__content}>
              <CalendarOfReservationOrganism setCalendarData={setCalendarData} filter={filter} />
            </div>
          </div> : filteredData?.length > 0 ? <SessionsCalendarGridView
            sessions={filteredData}
            showFilter={false}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>}
        </Container>
      </div>

      <DrawerHistoriqueOrganism
        open={openDrawerHistorique}
        setOpen={setOpenDrawerHistorique}
        classId={undefined}
        teacher={undefined}
        organismId={user?._id}
      />
    </React.Fragment>
  );
};

export default OrganismCalendar;
